import React from 'react';
import { arrayOf, shape, string, number, bool } from 'prop-types';
import { Icon, Tooltip } from '@fiverr-private/fit';
import { r_comment } from '@fiverr-private/icons';
import { I18n, translate } from '@fiverr-private/i18n-react';
import './style.scss';

const getTooltipContent = (languagesList) => languagesList.map((languageObj) => (
    <div className="language-wrapper" key={languageObj.name}>
        <I18n k={`languages.codes.${languageObj.name}`}/> (<I18n k={`languages.proficiencies.level_${languageObj.level}`}/>)
    </div>
));

const SellerLanguage = ({ sellerLanguages, commonLanguage, withLevel = true }) => {
    const showPlusMoreLabel = sellerLanguages.length > 1;
    const sellerLanguagesTooltip = getTooltipContent(sellerLanguages);

    return (
        <span className="seller-language">
            <Icon size={14} className="comment-icon">{r_comment}</Icon>
            <span>
                <I18n k={'gig_page_perseus.overview.language.speaks'}
                    params={{ language: translate(`languages.codes.${commonLanguage.name}`) }}/>
            </span>
            { withLevel &&
            <span className="common-language-level">
                (<I18n k={`languages.proficiencies.level_${commonLanguage.level}`}/>)
            </span>
            }
            {showPlusMoreLabel &&
                <Tooltip className="seller-languages-tooltip" boxContentClassName="tooltip-content" content={sellerLanguagesTooltip}>
                    <span className="plus-more-label">
                        <I18n k={'gig_page_perseus.overview.language.more'}
                            params={{ count: sellerLanguages.length - 1 }}/>
                    </span>
                </Tooltip>
            }
        </span>
    );
};

SellerLanguage.propTypes = {
    sellerLanguages: arrayOf(
        shape({
            name: string,
            level: number
        })
    ).isRequired,
    commonLanguage: shape({
        name: string,
        level: number
    }).isRequired,
    withLevel: bool
};

export default SellerLanguage;
